import React, { useCallback, useEffect, useMemo, useState } from 'react';
import '../SelectedHistory.scss';
import { observer } from 'mobx-react-lite';
import { tableBetHistoryStore } from '@pascal/pascal-core';
import LastRoundData from '../../fairness/lastRoundData';
import { TAB_INDEX_FOR_FAIRNESS } from '../../../core/constants/gameConstants';
import FairnessTabRowInfo from '../../fairness/fairnessTabRowInfo';
import useTranslation from '../../../hooks/useTranslation';
import FairnessInputsGroup from '../../fairness/fairnessInputsGroup';
import TicketWrapper from '../../ticketWrapper';
import TicketTitle from '../../ticketTitle';
import { userInfoStore } from '../../../store/userInfoStore';
import { parseNumberPrecisionByDoteCount } from '../../../core/helpers/parseNumberByPrecision';
import { checkHashStore } from '../../../store/checkHashStore';

export const SelectedRow = observer(() => {
  const { thirdStep } = tableBetHistoryStore;
  const { data: thirdStepData } = thirdStep;
  const { precision } = userInfoStore;
  const t = useTranslation();
  const [activeTabIndex, setActiveTabIndex] = useState(TAB_INDEX_FOR_FAIRNESS.History);

  const totalTicketAmount = useMemo(() => {
    return thirdStepData.roundData.reduce(
      (acc, current) => parseNumberPrecisionByDoteCount(acc + +current.amount, 1, precision),
      0
    );
  }, [thirdStepData, precision]);

  // const totalTicketsWinAmount = useMemo(() => {
  //   const winAmount = thirdStepData.roundData.reduce((acc, current) => {
  //     return acc.plus(current.winAmount);
  //   }, new Decimal(0));
  //   return parseNumberPrecisionByDoteCount(winAmount.valueOf(), 1, precision);
  // }, [thirdStepData, precision]);

  const handleSelectActiveTab = useCallback(
    (activeTab) => {
      if (activeTab === TAB_INDEX_FOR_FAIRNESS.Fairness) {
        checkHashStore.setSpinInfo(thirdStepData);
      }
      setActiveTabIndex(activeTab);
    },
    [thirdStepData]
  );

  useEffect(() => {
    return () => {
      checkHashStore.resetSpinInfo();
    };
  }, []);

  return (
    <div className='game-history-content'>
      <div className='game-history-lastresult-block'>
        <LastRoundData resultNumber={thirdStepData.resultNumber} />
      </div>
      <div className='game-history-inner'>
        <div className='betslip-tab-row-wrapper'>
          <FairnessTabRowInfo
            activeTabIndex={activeTabIndex}
            setActiveTabIndex={handleSelectActiveTab}
          />
        </div>
        <div className='history-bet-information-wrapper'>
          <div className='history-bet-information-content'>
            {/* History tab */}
            {activeTabIndex === TAB_INDEX_FOR_FAIRNESS.History ? (
              <div className='history-ticketsitem-list-wrapper'>
                <TicketTitle
                  t={t}
                  isBetsClosed
                  handleClearAllTickets={() => {}}
                  tickets={thirdStepData.roundData}
                  totalTicketAmount={totalTicketAmount}
                  currencyCode={userInfoStore.currencyCode}
                  totalTicketsWinAmount={thirdStepData.winAmount}
                />
                <TicketWrapper
                  t={t}
                  isBetsClosed
                  tickets={thirdStepData.roundData}
                  winNumbersForTickets={thirdStepData.resultNumber}
                  currencyCode={userInfoStore.currencyCode}
                />
              </div>
            ) : null}
            {activeTabIndex === TAB_INDEX_FOR_FAIRNESS.Fairness ? (
              <FairnessInputsGroup isFromBetHistory />
            ) : null}
          </div>
        </div>
      </div>
    </div>
  );
});
